import React from 'react';
import { Helmet } from 'react-helmet-async';

// Định nghĩa kiểu dữ liệu chặt chẽ cho các thuộc tính của bài viết
interface BlogSchemaProps {
  title: string;
  description: string;
  url: string;
  imageUrl: string;
  authorName: string;
  datePublished: string;
  dateModified: string;
}

const BlogSchema: React.FC<BlogSchemaProps> = ({
  title,
  description,
  url,
  imageUrl,
  authorName,
  datePublished,
  dateModified,
}) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "headline": title,
    "description": description,
    "image": [imageUrl],
    "author": {
      "@type": "Person",
      "name": authorName
    },
    "datePublished": datePublished,
    "dateModified": dateModified
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="article" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* 4. Đoạn mã dữ liệu cấu trúc Schema JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default BlogSchema;